import { Component, OnInit } from '@angular/core';
import { Arquivo } from 'src/app/model/arquivo';
import { BackendApiService } from 'src/app/services/backend-api.service';

@Component({
  selector: 'app-section-arquivos',
  templateUrl: './section-arquivos.component.html',
  styleUrls: ['./section-arquivos.component.scss'],
})
export class SectionArquivosComponent implements OnInit {
  arquivos: Arquivo[] = [];

  constructor(private backendApi: BackendApiService) {}

  ngOnInit(): void {
    this.backendApi.findAllArquivos().subscribe({
      next: (arquivos) => {
        this.arquivos = arquivos;
      },
      error: (err) => {
        console.error('Erro ao carregar arquivos:', err);
      },
    });
  }

  getDownloadUrl(arquivo: Arquivo): string {
    return this.backendApi.getArquivoDownloadUrl(arquivo.anexo);
  }
}
